import React, { useEffect, useState, useContext } from 'react';
import Header from '../Header/AppHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import FailureAlert from '../Common/Failure';
import { ThemeContext } from '../Common/ThemeProvider';
import QRCode from 'qrcode.react';
import * as htmlToImage from 'html-to-image';
import PickNTrackLogo from '../../Images/PickNTrackLogo.jpeg';
import { FetchUsers } from '../Common/Services/UserService';
import UserList from './ReusableComponents/UserList';

const MerchantCode = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    const [usersData, setusersData] = useState([]);
    const [FilterUsers, setFilterUsers] = useState([]);
    const [SelectedUsers, setSelectedUsers] = useState({});

    useEffect(() => {
        FetchUsersData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onUsersSearch = (searchValue) => {
        if (searchValue !== "") {
            let userSearchData = usersData.filter(c => c.FirstName.trim().toLowerCase().includes(searchValue.trim().toLowerCase()) ||
                c.LastName.trim().toLowerCase().includes(searchValue.trim().toLowerCase()) ||
                (c.Organization.length > 0 && c.Organization[0].Name.trim().toLowerCase().includes(searchValue.trim().toLowerCase())));
            setFilterUsers(userSearchData);
        }
        else {
            setFilterUsers(usersData);
        }
    };

    const FetchUsersData = () => {
        FetchUsers(null, UserSuccess, Failure);
    };

    const UserSuccess = (data) => {
        setusersData(data);
        setFilterUsers(data);
    };

    const GenerateQRCode = (userData) => {
        if (userData && userData._id !== "") {
            setSelectedUsers(userData);
        }
        else {
            setSelectedUsers("");
        }
    };

    const DownloadImage = () => {
        var node = document.getElementById('QRCodeImage');

        htmlToImage.toPng(node)
            .then(function (dataUrl) {
                var link = document.createElement('a');
                link.download = SelectedUsers.UserName + '_QRImage.png';
                link.href = dataUrl;
                link.click();
            })
            .catch(function (error) {
                console.error('oops, something went wrong!', error);
            });
    }

    const Failure = (err) => {
        FailureAlert(err);
    };

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme shadow sidemenu-show">
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <h5 className="align-center" style={{ fontWeight: "500" }}>Merchant Codes</h5>
                    </div>
                </div>
                <div className="col-md-12" style={{ height: "75vh" }}>
                    <div className="row" style={{ marginLeft: "5px", marginRight: "5px", height: "70vh" }}>
                        <div className="col-md-5" style={{
                            borderRight: "1px solid #ccc",
                            borderTop: "1px solid #ccc"
                        }}>

                            <div style={{ marginBottom: "20px", position: "relative" }}>
                                <input type="text" name="Name" placeholder="Search User..."
                                    className="input-control" style={{ outline: "none", marginRight: "10px", borderRadius: "20px", paddingLeft: "40px", borderTop: "none", borderTopLeftRadius: "0", borderTopRightRadius: "0" }}
                                    onChange={e => onUsersSearch(e.target.value)}></input>
                                <div className={`${CurrentTheme}Color`} style={{ fontSize: "1.1rem", position: "absolute", left: "89%", top: "13%" }}>
                                    <FontAwesomeIcon icon={faSearch} />
                                </div>
                            </div>
                            <div style={{ height: "65vh", padding: "0 10px", overflow: "auto", overflowX: "hidden" }}>
                                <UserList FilterUsers={FilterUsers} GenerateQRCode={GenerateQRCode} SelectedUsers={SelectedUsers}></UserList>
                            </div>
                        </div>
                        <div className="col-md-7" style={{
                            borderL: "1px solid #ccc",
                            borderTop: "1px solid #ccc", paddingTop: "10px"
                        }}>
                            <div className="row" style={{ display: "flex", justifyContent: "center" }}>
                                <div className="col-md-10 col-sm-12 col-sm-12">
                                    {SelectedUsers._id !== undefined &&
                                        SelectedUsers._id.toString() !== "" && (<div style={{ display: "flex", justifyContent: "space-around" }}>
                                            <div onClick={DownloadImage} title="Click to download..." className="cd-cards2 cd-cardboundry cursor"
                                                id="QRCodeImage" style={{
                                                    textAlign: "center", padding: "10px", minWidth: "300px",
                                                    borderRadius: "25px", border: "none", position: 'relative'
                                                }}>
                                                <div style={{ fontSize: "2.5rem", color: "white", lineHeight: "60px" }}>Scan & Move</div>
                                                <div style={{ fontSize: "2rem", color: "white", marginBottom: "10px" }}>Mfind</div>
                                                <img alt="Logo" style={{ position: "absolute", left: "42%", top: "56%", borderRadius: "50%" }} width="40" src={PickNTrackLogo}></img>
                                                <QRCode renderAs="svg" bgColor="white" size={250}
                                                    includeMargin={true} level="M"
                                                    value={SelectedUsers._id} />
                                                <div style={{ color: "white", marginTop: "10px" }}>www.mfind.net</div>
                                            </div>
                                        </div>)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MerchantCode;